export default __webpack_public_path__ + "static/media/instagram.f0cfa30d.svg";